import * as React from 'react';
import { WrappedFieldInputProps, WrappedFieldProps } from 'redux-form';
import { InputAdornment, withStyles, WithStyles } from '@material-ui/core';
import { StyleRules } from '@material-ui/core/styles';
import { compose, pure } from 'recompose';
import FieldLabel from './FieldLabel';
import * as cx from 'classnames';
import Input from '@material-ui/core/Input/Input';
import { Dispatch } from 'redux';

type CssClasses = 'input' | 'fullWidth' | 'rightAlign';
const styles: StyleRules<CssClasses> = {
  input: {
    backgroundColor: '#d6d6d6',
    border: 'solid 1px rgb(187, 187, 187)',
    paddingTop: '10px',
    paddingBottom: '10px',
    paddingLeft: '8px',
    paddingRight: '8px',
    fontFamily: 'Lato, Helvetica, Arial, Lucida, sans-serif',
    fontSize: '15px',
    color: 'rgb(78, 78, 78)',
    fontWeight: 400,
    '&::before': {
      borderBottom: '0px !important',
    },
    '&>*': {
      fontFamily: 'Lato, Helvetica, Arial, Lucida, sans-serif',
      fontSize: '15px',
      color: 'rgb(78, 78, 78)',
    },
  },
  rightAlign: {
    '&>*': {
      textAlign: 'right'
    }
  },
  fullWidth: {
    width: '100%',
  },
};

interface OwnProps {
  label?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  formControlClassName?: string;
  directError?: boolean;
  requireMark?: boolean;
  inputWidth?: string;
  containerWidth?: string;
  endAdornment?: string;
  alignRight?: boolean;
}

type Props = OwnProps & WrappedFieldProps;

interface InnerProps extends WithStyles<CssClasses> {
  dirty: boolean;
  error?: any;
  invalid: boolean;
  touched: boolean;
  input: WrappedFieldInputProps;
  label?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  formControlClassName?: string;
  directError?: boolean;
  requireMark?: boolean;
  inputWidth?: string;
  containerWidth?: string;
  endAdornment?: string;
  alignRight?: boolean;
}
const Inner: React.SFC<InnerProps> = (props: InnerProps) => {
  const {
    error,
    touched,
    dirty,
    invalid,
    input,
    label,
    disabled,
    directError,
    classes,
    requireMark,
    fullWidth,
    inputWidth,
    containerWidth,
    endAdornment,
    alignRight
  } = props;

  const inErrorState = invalid && (touched || dirty || directError);
  const width = fullWidth ? classes.fullWidth : null;
  const style = inputWidth != null ? { width: inputWidth } : {};
  const styleContainer = containerWidth != null ? { width: containerWidth } : {};
  const rightAlign = alignRight ? classes.rightAlign : null;

  let endAd: any = null;
  if (endAdornment !== undefined) {
    endAd = <InputAdornment position="end">{endAdornment}</InputAdornment>;
  }

  return (
    <div style={styleContainer}>
      {label && <FieldLabel text={label} required={requireMark} errorText={error} error={inErrorState} />}
      <div>
        <Input disabled={disabled} {...input} className={cx(classes.input, width, rightAlign)} style={style} endAdornment={endAd} />
      </div>
    </div>
  );
};

const PureInner = pure(Inner);

class FormTextField extends React.PureComponent<Props & WithStyles<CssClasses>> {
  public render() {
    const { meta, ...rest } = this.props;
    const { error, touched, dirty, invalid } = meta;
    return <PureInner error={error} touched={touched} dirty={dirty} invalid={invalid} {...rest} />;
  }
}

export default withStyles(styles)(FormTextField);



// WEBPACK FOOTER //
// ./src/components/FormTextField.tsx